import type { CmtsStoredSession } from "../auth/authStore.js";
import { buildCmtsPersonaLandingMap } from "./buildCmtsPersonaLandingMap.js";
import { normalizeCmtsRoles } from "../auth/normalizeCmtsRoles.js";
import { CMTS_ROLE_CODES } from "../auth/cmtsRoleCodes.js";

const personaLandingMap = buildCmtsPersonaLandingMap();

const FALLBACK_LANDING_PATH = "/cmts/my-workspace";

function landing(persona: string): string | undefined {
  const path = personaLandingMap.get(persona);

  if (!path || path === "/cmts" || path === "/cmts/login" || path === "/") {
    return undefined;
  }

  return path;
}

export function getCmtsPersonaLandingPath(
  session?: Pick<CmtsStoredSession, "roles" | "permissions"> | null
): string {
  const roles = new Set(normalizeCmtsRoles(session?.roles));
  const permissions = new Set(session?.permissions ?? []);

  const rolePriority = [
    CMTS_ROLE_CODES.SYSTEM_ADMIN,
    CMTS_ROLE_CODES.TENANT_ADMIN,
    CMTS_ROLE_CODES.MANAGEMENT,
    CMTS_ROLE_CODES.QUALITY_HEAD,
    CMTS_ROLE_CODES.QUALITY_MANAGER,
    CMTS_ROLE_CODES.DEPARTMENT_MANAGER,
    CMTS_ROLE_CODES.INVESTIGATOR,
    CMTS_ROLE_CODES.RCA_LEAD,
    CMTS_ROLE_CODES.CAPA_OWNER,
    CMTS_ROLE_CODES.VERIFICATION_OWNER,
    CMTS_ROLE_CODES.CUSTOMER_USER,
    CMTS_ROLE_CODES.SUPPLIER_USER,
    CMTS_ROLE_CODES.AUDITOR,
    CMTS_ROLE_CODES.REPORT_MANAGER,
    CMTS_ROLE_CODES.EVIDENCE_ADMIN,
    CMTS_ROLE_CODES.SECURITY_VIEWER,
  ];

  for (const role of rolePriority) {
    if (roles.has(role)) {
      return landing(role) ?? FALLBACK_LANDING_PATH;
    }
  }

  if (permissions.has("DASHBOARD.READ")) {
    return landing("PERMISSION:DASHBOARD.READ") ?? FALLBACK_LANDING_PATH;
  }

  return FALLBACK_LANDING_PATH;
}
